import Select, { components } from "react-select";
import { Children, FC } from "react";
import Colors from "../../constants/colors";

const { ValueContainer, Placeholder } = components;

const CustomValueContainer: FC<any> = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {Children.map(children, (child) => (child && child.type !== Placeholder ? child : null))}
    </ValueContainer>
  );
};

type StyledSelectWoControllerProps = {
  options: { value: string; label: string }[];
  onChange: (e: any) => void;
  className?: string;
  placeholder: string;
  isClearable?: boolean;
  value?: { value: string; label: string }[];
  isSearchable?: boolean;
};

export const StyledSelectMultiWoController = ({
  options,
  onChange,
  className,
  placeholder,
  isClearable = true,
  isSearchable = true,
  value,
}: StyledSelectWoControllerProps) => {
  return (
    <Select
      placeholder={placeholder}
      isClearable={isClearable}
      isSearchable={isSearchable}
      isMulti
      components={{
        IndicatorSeparator: () => null,
        ValueContainer: CustomValueContainer,
      }}
      value={value}
      options={options}
      onChange={onChange}
      className={className}
      closeMenuOnSelect={false}
      styles={{
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          transform: "translateY(0)",
          display: state.hasValue ? "none" : "block",
          fontSize: "0.9rem",
          fontWeight: "400",
          color: Colors.gray400,
        }),
      }}
    />
  );
};
